import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckCircle2, SendIcon, Camera, Smartphone, Dog, Gift, Percent, TrendingUp, BookOpen, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function CreatorProgram() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    petType: '',
    socialHandle: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const response = await fetch('https://api.pawchi.app/api/creator-applications', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          pet_kind: formState.petType,
          social_media_link: formState.socialHandle
        })
      });
      if (!response.ok) {
        throw new Error('Failed to submit application. Please try again.');
      }
      setSubmitted(true);
      setFormState({
        name: '',
        email: '',
        petType: '',
        socialHandle: ''
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }
  return <div className="min-h-screen bg-cream" data-id="element-924" data-mp="1pwigg8cnhf50">
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-id="element-925" data-mp="1uv3a1oxed0kh">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-926" data-mp="1uts35g8nncp5">
          <ArrowLeftIcon size={18} data-id="element-927" data-mp="36b1knx883unt" />
          Back to Home
        </Link>

        <div className="grid md:grid-cols-2 gap-16" data-id="element-928" data-mp="3b932yfxtrpy8">
          <div data-id="element-929" data-mp="3b7s0qkk12q98">
            <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-4 leading-tight" data-id="element-930" data-mp="3bbfthhhnf8mw">
              Join the{' '}
              <span className="text-peach" data-id="element-931" data-mp="2gmczahdplgcd">Pawchi Creator Program</span>
            </h1>
            <p className="text-warmBrown/80 text-lg mb-8 leading-relaxed" data-id="element-932" data-mp="2goh3l0fishd6">
              Love sharing your pet online? Get early access to Pawchi,
              exclusive perks, and earn money by creating content featuring your
              furry friend. Whether you're an established creator or just have a
              pet with a great personality, we'd love to partner with you!
            </p>

            <div className="bg-white rounded-3xl p-8 shadow-soft mb-8 border border-warmBrown/5" data-id="element-933" data-mp="2ckj0ken2qmeu">
              <h3 className="font-bold text-xl text-warmBrown mb-6" data-id="element-934" data-mp="27tswr5uaqrm9">
                Requirements
              </h3>
              <ul className="space-y-6" data-id="element-935" data-mp="1k3yhyiqf2szd">
                <li className="flex items-start gap-4" data-id="element-936" data-mp="1k2ngipkg1xbf">
                  <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-937" data-mp="1f5naufriawku">
                    <Dog size={20} data-id="element-938" data-mp="3qrp4ska156cg" />
                  </div>
                  <div data-id="element-939" data-mp="3vixfrkr0czrq">
                    <p className="font-bold text-warmBrown" data-id="element-940" data-mp="3vjh17bfva6ai">Own a dog or cat</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-941" data-mp="3gukp93aow94m">
                      Your pet is the star of the show.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-942" data-mp="ddkpqquut6sh">
                  <div className="w-10 h-10 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-943" data-mp="de3ypi2j0kud">
                    <Smartphone size={20} data-id="element-944" data-mp="4cwc3x9dh8g4" />
                  </div>
                  <div data-id="element-945" data-mp="4ccw4m3a8u4q">
                    <p className="font-bold text-warmBrown" data-id="element-946" data-mp="4f8pry83kwnd">Smartphone</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-947" data-mp="8cws3mc4drpa">
                      To record content and use the Pawchi app.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-948" data-mp="2t69yisypjpu2">
                  <div className="w-10 h-10 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-949" data-mp="39cd43o4xc9lk">
                    <Camera size={20} data-id="element-950" data-mp="34kcypg634ohl" />
                  </div>
                  <div data-id="element-951" data-mp="2zls6o40zlb48">
                    <p className="font-bold text-warmBrown" data-id="element-952" data-mp="2zn3d6bltgwz1">
                      Willing to record videos
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-953" data-mp="2uos0lt4508d4">
                      Comfortable filming everyday moments.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-soft mb-8 border border-warmBrown/5" data-id="element-954" data-mp="3icjdoyxi4pfg">
              <h3 className="font-bold text-xl text-warmBrown mb-6" data-id="element-955" data-mp="3eay69t3ql3cn">Rewards</h3>
              <ul className="space-y-6" data-id="element-956" data-mp="3ed0uc7lbwmeq">
                <li className="flex items-start gap-4" data-id="element-957" data-mp="26xw3qhktqmz0">
                  <div className="w-10 h-10 rounded-full bg-sage/10 text-sage flex items-center justify-center flex-shrink-0" data-id="element-958" data-mp="26v9umdiabzeo">
                    <Gift size={20} data-id="element-959" data-mp="ie0b7dm070rv" />
                  </div>
                  <div data-id="element-960" data-mp="ifl5d24eohp7">
                    <p className="font-bold text-warmBrown" data-id="element-961" data-mp="mfbsmvuq4foz">Free Pawchi Plus</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-962" data-mp="md94khd4swmw">
                      Get full access to all premium features.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-963" data-mp="w6g8ryw4y6le">
                  <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-964" data-mp="11519dzfausad">
                    <Percent size={20} data-id="element-965" data-mp="161rmcdvt57rk" />
                  </div>
                  <div data-id="element-966" data-mp="1a4egwmjv56sg">
                    <p className="font-bold text-warmBrown" data-id="element-967" data-mp="1a67r2btoq957">
                      Up to 20% affiliate commission!
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-968" data-mp="1f1n2kx47zsyg">
                      Earn money for every new user you bring in.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-969" data-mp="3gx797abhdxa2">
                  <div className="w-10 h-10 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-970" data-mp="o1xd37g46uvr">
                    <TrendingUp size={20} data-id="element-971" data-mp="j3vtmles0tjr" />
                  </div>
                  <div data-id="element-972" data-mp="x2dca4ptrfut">
                    <p className="font-bold text-warmBrown" data-id="element-973" data-mp="x2vdlfrcgk9l">
                      Bonuses for top-performing videos
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-974" data-mp="16z882fupr25e">
                      Extra rewards when your content goes viral.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <Link to="/creator/help" className="group block bg-gradient-to-br from-peach to-coral rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-shadow text-white" data-id="element-975" data-mp="1fqs24ooeonu1">
              <div className="flex items-center gap-3 mb-3" data-id="element-976" data-mp="1pqiv2lxbius0">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center" data-id="element-977" data-mp="1krxx6t5jgn6q">
                  <BookOpen size={20} data-id="element-978" data-mp="24e9fdjye18tb" />
                </div>
                <p className="text-xs font-bold uppercase tracking-wider text-white/80" data-id="element-979" data-mp="29cksc3jzbzfr">
                  Creator Resources
                </p>
              </div>
              <h3 className="font-black text-xl mb-2" data-id="element-980" data-mp="1ugv0vpw0yu3n">Visit the Help Center</h3>
              <p className="text-white/90 text-sm leading-relaxed mb-4" data-id="element-981" data-mp="1zcaecgq4enzj">
                Guides, protocols, and tips to help you grow your audience and
                earn more with Pawchi.
              </p>
              <span className="inline-flex items-center gap-2 font-bold text-sm group-hover:gap-3 transition-all" data-id="element-982" data-mp="1qehxv98nxaak">
                Browse guides
                <ArrowRight size={16} data-id="element-983" data-mp="1gmuapkj52few" />
              </span>
            </Link>
          </div>

          <div className="relative" data-id="element-984" data-mp="12nuk47c2fqg3">
            <div className="bg-white rounded-[2.5rem] p-8 md:p-10 shadow-soft-lg border border-warmBrown/5 sticky top-32" data-id="element-985" data-mp="12ovxwjkgur1i">
              <h3 className="text-2xl font-bold text-warmBrown mb-2" data-id="element-986" data-mp="16rah54s1rstb">
                Apply Now
              </h3>
              <p className="text-warmBrown/60 text-sm mb-8" data-id="element-987" data-mp="1n2cjmxt8s4q4">
                Fill out the form below and our team will get back to you within
                48 hours.
              </p>

              {submitted ? <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="bg-sage/10 border border-sage/30 rounded-2xl p-6 text-center" data-id="element-988" data-mp="187oi1uqypqfs">
                  <div className="w-12 h-12 bg-sage/20 text-sage rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-989" data-mp="ugb3ywbtpks5">
                    <CheckCircle2 size={24} data-id="element-990" data-mp="khu8pn5uqk0a" />
                  </div>
                  <h4 className="font-bold text-warmBrown mb-2" data-id="element-991" data-mp="kh2cqb8cek9h">
                    Application Received!
                  </h4>
                  <p className="text-sm text-warmBrown/70" data-id="element-992" data-mp="2s3lzemrywhgq">
                    Thanks for applying to the Pawchi Creator Program. We'll be
                    in touch soon.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-sm font-bold text-peach hover:text-peach/80 transition-colors" data-id="element-993" data-mp="314adfhhd2htm">
                    Submit another application
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-994" data-mp="2de66p18vm1ye">
                  {error && <div className="p-3 bg-coral/10 border border-coral/20 rounded-xl text-coral text-sm" data-id="element-995" data-mp="2idiv3qfebh33">
                      {error}
                    </div>}

                  <div data-id="element-996" data-mp="1ppelwuxm8lvn">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-997" data-mp="1po3ln53dpw9a">
                      Your Name
                    </label>
                    <input type="text" required value={formState.name} onChange={e => setFormState({
                  ...formState,
                  name: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="Jane Doe" data-id="element-998" data-mp="1ulvatrcn349s" />
                  </div>

                  <div data-id="element-999" data-mp="1ot7vfj5i4ug8">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-1000" data-mp="1osy5fvkginaj">
                      Email Address
                    </label>
                    <input type="email" required value={formState.email} onChange={e => setFormState({
                  ...formState,
                  email: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="jane@example.com" data-id="element-1001" data-mp="w63ov9qrg82c" />
                  </div>

                  <div data-id="element-1002" data-mp="2vhx1gr49t0kr">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-1003" data-mp="2qpm0dkxsn8qm">
                      What kind of pet do you have?
                    </label>
                    <input type="text" required value={formState.petType} onChange={e => setFormState({
                  ...formState,
                  petType: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="e.g. Golden Retriever, Calico Cat" data-id="element-1004" data-mp="2mlo3lgvxya0q" />
                  </div>

                  <div data-id="element-1005" data-mp="1t42p8izdkb8a">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-1006" data-mp="1t5m2e0pqi65u">
                      Primary Social Media Link
                    </label>
                    <input type="url" required value={formState.socialHandle} onChange={e => setFormState({
                  ...formState,
                  socialHandle: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="https://tiktok.com/@yourhandle" data-id="element-1007" data-mp="2lryjzi5dvt2f" />
                  </div>

                  <button type="submit" disabled={isLoading} className="w-full mt-4 px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 disabled:opacity-70 disabled:cursor-not-allowed transition-colors shadow-soft-lg flex items-center justify-center gap-2" data-id="element-1008" data-mp="12sh45cebrywf">
                    {isLoading ? 'Submitting...' : <>
                        Submit Application
                        <SendIcon size={18} data-id="element-1009" data-mp="f6an60mxb8u2" />
                      </>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}